<template>
  <a :href="link" target="_blank" class="link with-arrow">
    <SpriteSymbol name="tram" />
    <span>{{ $texts('publicTransport') }}</span>
  </a>
</template>

<script lang="ts" setup>
const { $texts } = useEasyTexts()
const currentLanguage = useCurrentLanguage()

const props = defineProps<{
  station: string
}>()

const link = computed(() => {
  const lang = currentLanguage.value === 'de' ? 'de' : 'en'
  return `https://www.zvv.ch/zvv/${lang}/fahrplan/fp.html?toname=${encodeURI(props.station)}`
})
</script>
